<template>
  <div>
    <p class="title">{{ schedule.Contato }}</p>
    <div class="container">
      <form>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Data</label>
          <div class="col-sm-4">
            <input type="text" v-mask="'##/##/####'" class="form-control form-control-sm" v-model="edit.data" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Hora</label>
          <div class="col-sm-4">
            <input v-model="edit.hora" v-mask="'##:##:##'" type="text" class="form-control form-control-sm" placeholder="Hora">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Observação</label>
          <div class="col-sm-10">
            <textarea @keyup="keepLimit" v-model="edit.obs" rows="4" class="form-control form-control-sm" placeholder="Observação"></textarea>
            <span class="badge badge-secondary badge-sm mt-1 float-right">{{ limit }}</span>
          </div>
        </div>
      </form>

      <hr>

      <div class="row mt-4">
        <div class="col mb-3">
          <button class="btn btn-success btn-sm" :disabled="isOnProcessing" @click="save(edit)">
            <i v-show="!isOnProcessing" class="fa fa-check-square-o"></i>
            <i v-show="isOnProcessing" class="fa fa-spin fa-spinner"></i> SALVAR</button>
          <button class="btn btn-outline-secondary btn-sm" :disabled="isOnProcessing" @click="cancel"><i class="fa fa-close"></i> FECHAR</button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import localDatepicker from "../../../Utils/VueDatepickerLocal.js";
import { scheduleService } from "../../../service/";

export default {
  name: "ScheduleEdit",

  props: {
    schedule: {
      type: Object,
      required: true,
      default: {}
    }
  },

  data() {
    return {
      localDatepicker,
      countLimit: 100,
      isOnProcessing: false,
      edit: {
        data: "",
        hora: "",
        obs: ""
      }
    };
  },

  mounted() {
    this.localDatepicker = localDatepicker;
    this.edit = this.schedule;

    this.edit.data = this.$options.filters.dateISOFormat(this.schedule.data);
    this.edit.hora = this.$options.filters.timeFormat(this.schedule.hora);
    this.edit.obs = this.schedule.obs;
  },

  methods: {
    _showMessage(message, type) {
      this.$message({
        showClose: true,
        message: message,
        type: type
      });
    },

    _validation(schedule) {
      return new Promise((resolve, reject) => {
        let reverseDate = schedule.data.split("/")
          .reverse()
          .join("-");

        schedule.data = this.$moment(reverseDate).format("YYYY-MM-DD");
        let today = this.$moment();

        if (new Date(schedule.data) < new Date(today.format("YYYY-MM-DD")))
          return reject(
            new Error(
              `Data para agendamento não deve ser inferior a ${today.format(
                "DD/MM/YYYY"
              )}.`
            )
          );
        resolve(schedule);
      });
    },

    save(edit) {
      let schedule = (this.isOnProcessing = true);
      this._validation(Object.assign({}, edit))
        .then(schedule =>
          scheduleService
            .update(schedule)
            .then(schedule => {
              this.isOnProcessing = false;
              this._showMessage("Agendamento atualizado", "success");
              this.$emit("confirm", schedule);
            })
            .catch(err => err.json().then(r => Promise.reject(r)))
        )
        .catch(err => {
          this.isOnProcessing = false;
          this._showMessage(err.message, "error");
        });
    },

    cancel() {
      this.$emit("cancel", {});
    },

    keepLimit() {
      if (this.limit <= 0) this.edit.obs = this.edit.obs.substring(0, 100);
    }
  },

  computed: {
    limit() {
      return this.countLimit - this.edit.obs.length || 0;
    }
  }
};
</script>




// WEBPACK FOOTER //
// ScheduleEdit.vue?c9faef3a